export default __webpack_public_path__ + "static/media/store-link.b8e8a027.svg";